import React, { useState } from "react";
import "./Chat.css"


import Convos from "./Convos";
import Contacts from "./Contacts";
import Config from "./ChatConfig";
import ChatView from "./ChatView"

import chatlogo from '../../assets/iconos/dialogo.svg'
import closeIcon from '../../assets/iconos/cerrar.png'
import Settings from '../../assets/iconos/tuerca.png'
import ChevronGreen from '../../assets/iconos/chevron-verde.svg'


function Chat(){

    
    

    ///Abro y cierro menu
    const [active,setActive] = useState(false)

    const activateNav = () => {
            setActive (!active)}

    ///Elijo componente a renderizar
    const [frame,setFrame] = useState(0);
        
    const changeNav = (x) => {
        setFrame (x)
    }
   

    const [selectedUserChat, setSelectedUserChat] = useState();

    ///Titulos para sidebar
    const titles = ["Conversaciones", "Contactos", "Ajustes", "Chat"]
    
   
    
    const  HandleUserChange = (user) => {
        
        setSelectedUserChat(user);
        
    }


    const { pathname } = '' //useLocation();
    if (pathname === "/buzon") {
    return <></>;}

return(
<div className="sidebar-container" > 
    <div className={active ? "chat-open" : 'chat-closed'}>
        <div>
        <div className="chat-title">
                <div className='contacts-title'>
                    <img src={ChevronGreen} onClick={() => changeNav(0)}  alt="go back" className={!frame ? "contacts-title-closed" : 'chat-icon sethoverdark setpointer'}/>
                    <h3>{titles[frame]}</h3>
                </div>
            <img src={Settings} alt="settings" onClick={() => changeNav(2)} className="chat-icon setpointer sethoverdark turnwhite" />
            <img src={closeIcon} alt="close icon" className="chat-icon setpointer sethoverdark" onClick={activateNav}/>
        </div>
    </div>
    
    { 
        !frame ? <Convos changeNav={() => {changeNav(1)}} changeNav2={(user) => {changeNav(3); HandleUserChange(user)}} frame/> : RenderX(frame, selectedUserChat)
    }
    
    </div>
</div>
    );
}

function RenderX(fr, selectedUserChat){
    if(fr===1){
            return <Contacts />
            }
    else if(fr===2){
            return <Config />
            }
    else if(fr===3){
            return <ChatView user={selectedUserChat} />
            }
}



export default Chat